function base64Encode(content: string): string {
  return Buffer.from(content, 'utf-8').toString('base64');
}

function createEml({
  to,
  from,
  subject,
  text,
  html,
}: {
  to?: string;
  from?: string;
  subject: string;
  text: string;
  html: string;
}) {
  const boundary = 'boundary123';
  const encodedText = base64Encode(text);
  const encodedHtml = base64Encode(html);
  return (
    `From: ${from || ''}\r\n` +
    `To: ${to || ''}\r\n` +
    `Subject: ${subject}\r\n` +
    `MIME-Version: 1.0\r\n` +
    `Content-Type: multipart/alternative; boundary="${boundary}"\r\n` +
    `X-Unsent: 1\r\n\r\n` +
    `--${boundary}\r\n` +
    `Content-Type: text/plain; charset="UTF-8"\r\n` +
    `Content-Transfer-Encoding: base64\r\n\r\n` +
    `${encodedText}\r\n\r\n` +
    `--${boundary}\r\n` +
    `Content-Type: text/html; charset="UTF-8"\r\n` +
    `Content-Transfer-Encoding: base64\r\n\r\n` +
    `${encodedHtml}\r\n\r\n` +
    `--${boundary}--`
  );
}

export default createEml;
